const moment = require('dayjs')

const timer = {}

timer.getYMD = function getYMD (str) {
  const date = moment(str)
  return {
    year: date.year(),
    month: date.month() + 1,
    date: date.date()
  }
}

timer.fmMD = function fmMD (str) {
  return moment(str).format('MM/DD')
}

timer.fmMDY = function fmMDY (str) {
  return moment(str).format('MM/DD/YYYY')
}

timer.fmMDYHM = function fmMDYHM (str) {
  return moment(str).format('MM/DD/YYYY HH:mm')
}

timer.fmMDYHMS = function fmMDYHM (str) {
  return moment(str).format('MM/DD/YYYY HH:mm:ss')
}

timer.fmYMD = function fmMDYHM (str) {
  return moment(str).format('YYYY-MM-DD')
}

timer.isBefore = function isBefore (str1, str2, format = 'MM/DD/YYYY') {
  return moment(str1, format).isBefore(moment(str2, format))
}

timer.isAfter = function isAfter (str1, str2, format = 'MM/DD/YYYY') {
  return moment(str1, format).isAfter(moment(str2, format))
}

/**
 * 获取近n天日期范围
 * @param {Number} inervalDays 天数
 * @return {Object}
 */
timer.getDayRange = function getDateRange (inervalDays) {
  const oneDayTime = 24 * 60 * 60 * 1000
  const endTime = new Date()
  const startTime = new Date(endTime.getTime() - inervalDays * oneDayTime)
  return {
    startTime: timer.fmMDY(startTime),
    endTime: timer.fmMDY(endTime)
  }
}

timer.subtract = function subtract (first, second, type = 'days') {
  return moment(first).diff(second, type)
}

/**
 * 获取近n月日期范围
 * @param {Number} inervalMonths 天数
 * @return {Object}
 */
timer.getMonthRange = function getDateRange (inervalMonths) {
  const now = new Date()
  let year = now.getFullYear()
  let month = now.getMonth() + 1
  let day = now.getDate()

  month -= inervalMonths
  if (month <= 0) {
    month += 12
    year--
  }
  const tmpDay = new Date(year, month, 0).getDate()
  day = tmpDay >= day ? day : tmpDay

  return {
    startTime: timer.fmMDY(`${year}/${month}/${day}`),
    endTime: timer.fmMDY(now)
  }
}

export default timer
